import { render, staticRenderFns } from "./IconCompleted.vue?vue&type=template&id=a0156384&v-if=value"
import script from "./IconCompleted.vue?vue&type=script&lang=js"
export * from "./IconCompleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports